import { View } from "ui/atoms/view";
import { Text } from "react-native";
import ViewDocuments from "../../../components/molecules/ViewDocuments";
import { BodyMapEntryLogModel } from "../../../services/api/types/bodyMap/models/BodyMapEntryLogModel";
import { format } from "date-fns";
import { Icon } from "ui/gluestack/icon";
import { EllipseIcon } from "ui/gluestack/icon/EllipseIcon";

interface Props {
  log: BodyMapEntryLogModel;
}
export function BodyMapEntryUpdate({ log }: Props) {
  return (
    <View className="flex-row">
      <View className="items-center">
        <Icon as={EllipseIcon} className="h-3.5 mb-1" />
        <View className="flex-1 border-l border-border-300" />
      </View>

      <View className="flex-1">
        <Text className="ml-8 mb-4 text-sm font-normal text-typography-600">
          {format(new Date(log.created_at), "dd-MM-yyyy 'at' HH:mm")}
        </Text>

        <View className=" pl-8">
          <View className="gap-2">
            <Text className="text-base font-medium text-primary-700">
              New update
            </Text>
            <Text className="text-base font-normal text-typography-800">
              {log.comment}
            </Text>
          </View>
          <ViewDocuments documents={log.images ?? []} className="mt-5 mb-7" />
        </View>
      </View>
    </View>
  );
}
